export default "__VITE_ASSET__DW0$6G1g__"